import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ScaffoldDialogRef } from '@app/framework/dialog/scaffold-dialog.service';
import { NotificationsService } from '@services/notifications.service';
import { TranslationService } from '@services/translation.service';
import { UserService } from '@services/user.service';

@Component({
  selector: 'app-verify-modal',
  templateUrl: './verify-modal.component.html',
  styleUrls: ['./verify-modal.component.scss'],
  standalone: false,
})
export class VerifyModalComponent implements OnInit {
  public data = {};
  public verificationCodeControl = new FormControl('');
  public isLoading: boolean = true;
  isProcessing: boolean;

  constructor(
    private dialogRef: ScaffoldDialogRef,
    private userService: UserService,
    private notifications: NotificationsService,
    private translationService: TranslationService
  ) {}

  get type() {
    return this.data?.['contactType'];
  }

  ngOnInit(): void {
    this.userService.getVerificationCode(this.data?.['contactType']).subscribe(
      response => {
        if (response?.status !== 'verification sent') {
          const text = this.translationService.getTranslatedContent(
            'error_sending_verification_code_at_this_time',
            'Error Sending Verification Code at this time'
          );

          this.notifications.popNotification('', text);
          this.dialogRef.close(false);
          return;
        }
        this.isLoading = false;
      },
      err => {
        console.log('err', err);

        this.notifications.popNotification(
          '',
          this.translationService.getTranslatedContent(
            'error_sending_verification_code_at_this_time',
            'Error Sending Verification Code at this time'
          )
        );
        this.dialogRef.close(false);
      }
    );
  }

  handleClose() {
    this.dialogRef.close(false);
  }

  sendVerificataion() {
    this.isProcessing = true;
    this.userService
      .sendVerficationCode(this.type, this.verificationCodeControl.value)
      .subscribe(
        data => {
          const type = this.type === 'email' ? 'Email' : 'Phone Number';
          this.isProcessing = false;

          if (!data || data.error) {
            const text = this.translationService.getTranslatedContent(
              'error_attempting_to_validate',
              'Error Attempting to Validate'
            );

            const typeText = this.translationService.getTranslatedContent(
              type?.toLowerCase(),
              type
            );

            this.notifications.popNotification(
              `${text} `,
              typeText + ': ' + (data?.error ?? '')
            );

            this.dialogRef.close(false);
            return;
          }
          const typeText = this.translationService.getTranslatedContent(
            type?.toLowerCase(),
            type
          );
          const verifiedText = this.translationService.getTranslatedContent(
            'verified',
            'Verified'
          );

          this.notifications.popNotification('', typeText + ' ' + verifiedText);
          this.dialogRef.close(true);
        },
        err => {
          console.log(err);
          const text = this.translationService.getTranslatedContent(
            'error_attempting_to_validate',
            'Error Attempting to Validate'
          );

          this.notifications.popNotification(
            '',
            text + ': ' + err?.message || ''
          );
          this.isProcessing = false;
          this.dialogRef.close(false);
        }
      );
  }
}
